/* eslint-disable react-hooks/exhaustive-deps*/

import React, { useState, useEffect } from 'react';
import css from './ListingSearch.module.css';
import { withRouter } from 'react-router-dom';

import SearchFilterWrapper from '../../wrappers/search-filter-wrapper/SearchFilterWrapper';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSlidersH, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

import SkyLight from 'react-skylight';

import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routeConfiguration';
import Geocoder from '../../../components/LocationAutocompleteInput/GeocoderMapbox';

const POPULAR_TAGS = [
  { label: 'Leadership', keywords: 'Leadership' },
  { label: 'Executive', keywords: 'Executive' },
  { label: 'Career Change', keywords: 'Career Change' },
  { label: 'Confidence', keywords: 'Confidence' },
  { label: 'AI Skills', keywords: 'AI Skills' },
  { label: 'Wellbeing', keywords: 'Wellbeing' },
];

function ListingSearch(props) {
  const { searchParams } = props;

  const [filters, setFilters] = useState({});

  const geocoder = new Geocoder();
  const [predictions, setPredictions] = useState({ query: '', list: [] });

  useEffect(() => {
    setFilters({ ...filters, keywords: searchParams.keywords });
  }, []);

  let myBigGreenDialog =
    window.outerWidth > 768
      ? {
          backgroundColor: '#ffffff',
          color: '#000',
          width: '60%',
          borderRadius: '9px',
          top: '30%',
          left: '43%',
        }
      : {
          width: 'auto',
          marginTop: '0',
          marginLeft: 0,
          minHeight: '100px',
          top: '50px',
          left: '20px',
          right: '20px',
        };

  const onSearchButtonClick = () => {
    props.history.push(
      createResourceLocatorString('SearchPage', routeConfiguration(), {}, {
        ...searchParams,
        ...filters,
      })
    );
  };

  let modal;
  const onFilterClick = () => {
    modal.show();
  };

  const onLocationChange = e => {
    e.persist();
    geocoder
      .getPlacePredictions(e.target.value && e.target.value.length > 0 ? e.target.value : '')
      .then(res => {
        setPredictions({ list: res.predictions });
        geocoder
          .getPlaceDetails(res.predictions[0])
          .then(res1 => {
            setFilters({
              ...filters,
              address: res1.address,
              bounds: `${res1.bounds.ne.lat},${res1.bounds.ne.lng},${res1.bounds.sw.lat},${res1.bounds.sw.lng}`,
            });
          })
          .catch(err => console.log(err));
      })
      .catch(err => {
        console.log(err);
        setPredictions({ list: [] });
      });
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      onSearchButtonClick();
    }
  };

  const onTagClick = keywords => {
    props.history.push(
      createResourceLocatorString('SearchPage', routeConfiguration(), {}, { keywords })
    );
  };

  return (
    <div className={css.hero}>
      {/* modal for mobile filter */}
      <SkyLight dialogStyles={myBigGreenDialog} hideOnOverlayClicked ref={ref => (modal = ref)}>
        <SearchFilterWrapper searchParams={searchParams} onHideEvent={() => modal.hide()} />
      </SkyLight>

      <p className={css.marketplace}>VIVEKA MARKETPLACE</p>
      <h1 className={css.heading}>Find your coach. Start your growth.</h1>
      <p className={css.subtitle}>Browse vetted coaches by specialty, style, and availability.</p>

      {/* search bar */}
      <div className={css.searchBar}>
        <div className={css.keywordWrap}>
          <FontAwesomeIcon className={css.inputIcon} icon={faSearch} />
          <input
            value={filters.keywords || ''}
            onChange={e => setFilters({ ...filters, keywords: e.target.value })}
            className={css.keywordInput}
            type="text"
            placeholder="Skill, topic, or coach name..."
            onKeyPress={handleKeyPress}
          />
        </div>

        <div className={css.divider} />

        <div className={css.locationWrap}>
          <FontAwesomeIcon className={css.inputIcon} icon={faMapMarkerAlt} />
          <input
            list="searchResultsHero"
            onChange={onLocationChange}
            className={css.locationInput}
            type="text"
            placeholder="Location"
            onKeyPress={handleKeyPress}
          />
          <datalist id="searchResultsHero">
            {predictions.list.map((item, index) => (
              <option key={index}>{item.place_name_en}</option>
            ))}
          </datalist>
        </div>

        <button className={css.searchBtn} onClick={onSearchButtonClick}>
          <FontAwesomeIcon icon={faSearch} />
          <span>Search</span>
        </button>

        {/* mobile-only filter button */}
        <button className={css.mobileFilterBtn} onClick={onFilterClick}>
          <FontAwesomeIcon icon={faSlidersH} />
        </button>
      </div>

      {/* popular tags */}
      <div className={css.popularRow}>
        <span className={css.popularLabel}>Popular:</span>
        {POPULAR_TAGS.map(tag => (
          <button key={tag.keywords} className={css.popularTag} onClick={() => onTagClick(tag.keywords)}>
            {tag.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default withRouter(ListingSearch);
